import React from "react";
import { Images } from "lucide-react";

import { EllipsisMenu } from "../../menu/ellipsis/EllipsisMenu";

import "./AlbumCard.css";

const AlbumCard = ({ album, onClick, showMenu = false, menuOptions = [] }) => {
  const previewImages = Array.isArray(album?.images) ? album.images : [];

  const thumbnailImage = previewImages[0];

  const totalImages = Number(album?.totalImages ?? previewImages.length);

  const hasThumbnail = Boolean(thumbnailImage?.imageUrl);
  const hasMultipleImages = totalImages > 1;

  const handleCardClick = () => {
    if (!album?.albumId) return;

    onClick?.(album.albumId);
  };

  return (
    <article className="album-card">
      <button
        type="button"
        className="album-card__action"
        onClick={handleCardClick}
        disabled={!album?.albumId}
        aria-label={`Open ${album?.title || "album"}`}
      >
        <div className="album-card__thumbnail">
          {hasThumbnail ? (
            <img
              src={thumbnailImage.imageUrl || thumbnailImage.imageUrl}
              alt={album?.title || "Album thumbnail"}
              className="album-card__image"
              draggable={false}
              loading="lazy"
            />
          ) : (
            <div className="album-card__placeholder">
              <Images size={32} strokeWidth={1.8} aria-hidden="true" />
            </div>
          )}

          {hasMultipleImages && (
            <div
              className="album-card__multiple-icon"
              title={`${totalImages} photos`}
              role="img"
              aria-label={`${totalImages} photos`}
            >
              <span className="album-card__multiple-icon-back" />
              <span className="album-card__multiple-icon-front" />
            </div>
          )}
        </div>
      </button>

      {showMenu && (
        <div
          className="album-card__menu"
          onClick={(event) => event.stopPropagation()}
        >
          <EllipsisMenu options={menuOptions} />
        </div>
      )}
    </article>
  );
};

export default AlbumCard;
